<template>
  <div id="quiz-modal" class="ui modal">
    <i tabindex="0" class="close inside icon" />
    <div class="header"><span class="ui blue text">{{ profile.title }}</span></div>
    <div class="ui message quizMessage" :class="setGradeBanner" v-if="submitted">
      <p class="quizResponseMessage" v-html="message"></p>
      <p v-if="!error">You scored <span class="score" v-html="score"></span>%.
        <span v-if="!passed"> You needed <span class="score" v-html="quiz.pass_percentage * 100"></span>% to pass.</span></p>
        <button v-if="showRetakeQuizButton" id="retake-quiz" class="ui green button" @click="retakeQuiz">Retake Quiz</button>
        <button class="ui green button" @click="save">Save And Close</button>
    </div>
    <div class="scrolling content">
      <div class="ui form">
        <Question
          ref="question"
          v-for="(question, index) in quiz.questions"
          :key="index"
          :index="index"
          :length="quiz.questions.length"
          :question="question"
          @select="select"
          @remove="remove"
          :submitted="submitted"
        />
      </div>
    </div>
    <div class="actions">
      <button tabindex="0" class="ui green button" :class="{ disabled: disableSubmit }" @click="gradeQuiz">Submit</button>
      <button tabindex="0" class="ui grey button" @click="hideModal">Close</button>
    </div>
  </div>
</template>

<script>
import Question from './Question';
import ContentService from '@/services/api/content/content-service';
import ScormService from '@/services/scorm/scorm';
import { mapGetters } from 'vuex';

export default {
  name: 'QuizModal',
  components: {
    Question,
  },
  data() {
    return {
      selected: [],
      submitted: false,
      attempts: 0,
      passed: false,
      message: undefined,
      score: undefined,
      error: false,
    };
  },
  computed: {
    ...mapGetters({ loading: 'loadingProfile' }),
    syncguid() {
      return this.$route.params.syncguid;
    },
    standard() {
      return this.$route.params.standard;
    },
    profile() {
      return !this.loading ? this.$store.getters.contentById(this.syncguid).profile : {};
    },
    quiz() {
      if (!this.loading) {
        const quiz = this.$store.getters.contentById(this.syncguid).quiz;
        if (quiz.questioning_order === 'Random') {
          this.shuffle(quiz.questions);
        }
        return quiz;
      } else return {};
    },
    numberOfQuestionsToAnswer() {
      return !this.loading ? this.quiz.questions.length : null;
    },
    disableSubmit() {
      return this.selected.length !== this.numberOfQuestionsToAnswer || this.submitted === true;
    },
    setGradeBannerColors() {
      return this.passed ? 'success' : 'error';
    },
    showRetakeQuizButton() {
      return this.submitted && this.canRetakeQuiz && this.score < 100;
    },
    canRetakeQuiz() {
      return this.quiz.learner_attempt === 'Unlimited' || this.attempts < this.quiz.learner_attempt;
    },
    setGradeBannerHeight() {
      return this.error ? 'short' : 'tall';
    },
    setGradeBanner() {
      return `${this.setGradeBannerColors} ${this.setGradeBannerHeight}`;
    },
  },
  methods: {
    showModal() {
      const _this = this;
      this.$store.commit('video/addEvent', { id: 'pause' });
      $('#quiz-modal').modal({
        autofocus: false,
        onVisible: function() {
          $('.close.inside.icon').on('keyup', (e) => {
            var keycode = (e.keyCode ? e.keyCode : e.which);
            if (keycode === 13) {
              $('.close.inside.icon').click();
            }
          });
          $('.close.inside.icon').focus();
        },
        onHidden() {
          _this.$store.commit('video/addEvent', { id: 'play' });
        },
      }).modal('show');
    },
    hideModal() {
      $('#quiz-modal').modal('hide');
    },
    shuffle(arr) {
      for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [arr[i], arr[j]] = [arr[j], arr[i]];
      }
    },
    select(val) {
      if (!this.selected.includes(val)) {
        this.selected.push(val);
      }
    },
    remove(val) {
      this.selected = this.selected.filter(s => s !== val);
    },
    gradeQuiz() {
      this.submitted = false;
      ContentService.gradeQuiz(this.syncguid, this.selected).then(res => {
        this.passed = res.passed;
        this.message = res.message;
        this.attempts++;
        this.score = res.score;
        this.submitted = true;
        this.$store.commit('video/addEvent', {
          id: 'submitQuiz',
          value: { passed: res.passed, score: res.score },
        });
        this.$nextTick(() => {
          $('#retake-quiz').focus();
        });
        if (this.standard !== 'AICC') {
          ScormService.saveSCORMQuiz(res.score, this.quiz.pass_percentage);
        }
      }).catch(() => {
        this.message = 'Something went wrong trying to grade your quiz.';
        this.error = true;
        this.submitted = true;
      });
    },
    retakeQuiz() {
      if (this.canRetakeQuiz) {
        this.clearQuiz();
      } else {
        this.message = 'You have run out of attempts';
        this.error = true;
      }
    },
    clearQuiz() {
      this.submitted = false;
      this.selected = [];
      this.quiz.questions.forEach((question, i) => {
        question.choices.forEach(choice => {
          choice.selected = false;
        });
        this.$refs.question[i].reset();
      });
    },
    save() {
      this.$store.commit('video/addEvent', { id: 'exitSession' });
      $('#quiz-modal').modal('hide');
    },
  },
};
</script>
<style lang="less" scoped>
  :where(
    .close.inside.icon,
    .actions>button,
    .ui.message.quizMessage>button
  ):focus-within
  {
    border: 1px solid black;
  }
</style>
